export default {
  LIST_PROJECT: '/sales/wm/project/listProjectByPage',
  //保存或者修改项目，通过是否有id来判断
  SAVEOREDIT: '/sales/wm/project/saveWmProject',
  DETAIL: '/sales/wm/project/getProject',
  DISCARD: '/sales/wm/project/discard',
  INPASSEDIT: '/sales/wm/project/inPassEdit',
  QUERYWAREHOUSE: '/sales/contractInfo/listContractByPage',
  QUERYSUPERVISE: '/econo/superviseContract/list',
};
